module.exports = __webpack_public_path__ + "static/media/home-telehandlers.aed772c9.jpg";